import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { logout } from "../actions/auth"
import {
	fetchUsers,
	getUsersPaginated,
	updateUser,
	UserData,
	UsersListResponse,
	UsersListState,
} from "../actions/user"

const initialState: UsersListState = {
	loading: false,
	loadingFetch: false,
	error: undefined,
	errorFetch: undefined,
	list: undefined,
}

const usersPaginatedSlice = createSlice({
	name: "usersPaginated",
	initialState,
	reducers: {
		clearError: (state: UsersListState) => {
			state.error = undefined
			state.loading = false
		},
		resetDefault: (state: UsersListState) => {
			state.loading = false
			state.loadingFetch = false
			state.error = undefined
			state.errorFetch = undefined
			state.list = undefined
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(logout.fulfilled, () => initialState)
			.addCase(getUsersPaginated.pending, (state: UsersListState) => {
				state.loading = true
				state.error = undefined
			})
			.addCase(
				getUsersPaginated.fulfilled,
				(state: UsersListState, action: PayloadAction<UsersListResponse>) => {
					state.loading = false
					state.error = undefined
					state.list = action?.payload
				}
			)
			.addCase(getUsersPaginated.rejected, (state: UsersListState, action) => {
				state.loading = false
				state.error = action?.payload?.message || action?.message
			})
			.addCase(fetchUsers.pending, (state: UsersListState) => {
				state.loadingFetch = true
				state.errorFetch = undefined
			})
			.addCase(
				fetchUsers.fulfilled,
				(state: UsersListState, action: PayloadAction<UsersListResponse>) => {
					state.loadingFetch = false
					state.errorFetch = undefined
					state.list = {
						nextUrl: action?.payload.nextUrl,
						page: {
							...action?.payload.page,
							content: [
								...state?.list?.page?.content,
								...action?.payload?.page?.content,
							],
						},
					}
				}
			)
			.addCase(fetchUsers.rejected, (state: UsersListState, action) => {
				state.loadingFetch = false
				state.errorFetch = action?.payload.message
			})
			.addCase(
				updateUser.fulfilled,
				(state: UsersListState, action: PayloadAction<UserData>) => {
					state.list = {
						...state.list,
						page: {
							...state.list?.page,
							content: state.list?.page?.content?.map(
								(currentUser: UserData) =>
									currentUser.username === action?.payload?.data?.username
										? action?.payload?.data
										: currentUser
							),
						},
					}
				}
			)
	},
})

export const { clearError, resetDefault } = usersPaginatedSlice.actions

export default usersPaginatedSlice.reducer
